import { createContext, useContext, useState, useCallback } from 'react';
import type { ReactNode } from 'react';
import type { Card } from '@mtg-deck-tool/shared';

interface CardPreviewContextValue {
  /** The card currently being previewed. Null means show commander. */
  hoveredCard: Card | null;
  setHoveredCard: (card: Card | null) => void;
}

const CardPreviewContext = createContext<CardPreviewContextValue | null>(null);

export function CardPreviewProvider({ children }: { children: ReactNode }) {
  const [hoveredCard, setHoveredCardRaw] = useState<Card | null>(null);
  const setHoveredCard = useCallback((card: Card | null) => {
    setHoveredCardRaw(card);
  }, []);

  return (
    <CardPreviewContext.Provider value={{ hoveredCard, setHoveredCard }}>
      {children}
    </CardPreviewContext.Provider>
  );
}

export function useCardPreview(): CardPreviewContextValue {
  const ctx = useContext(CardPreviewContext);
  if (!ctx) {
    throw new Error('useCardPreview must be used within a CardPreviewProvider');
  }
  return ctx;
}
